import type { EditorPluginConfig, ViewerPluginConfig } from 'wix-rich-content-common';

export const IMAGE_TYPE = 'wix-draft-plugin-image';
export const IMAGE_TYPE_LEGACY = 'IMAGE';

export type ImageEditorWixSettings = {
  initiator: string;
  siteToken: string;
  metaSiteId: string;
  mediaRoot: string;
};

/*
 * @deprecated Not possible to configure.
 */
export interface ImageConfig {
  size?: string;
  alignment?: string;
  showTitle?: boolean;
  showDescription?: boolean;
  link?: {
    anchor: unknown;
    url: string;
  };
  width?: number;
  textWrap?: string;
  spoiler?: SpoilerConfig;
}

type SpoilerConfig = {
  buttonContent?: string | undefined;
  description?: string | undefined;
  enabled: boolean | undefined;
};

export interface ImagePluginEditorConfig extends EditorPluginConfig, ImageConfig {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  /*
   * @default false
   */
  disableDownload?: boolean;
  /*
   * @default false
   */
  disableExpand?: boolean;

  imageEditorWixSettings?: ImageEditorWixSettings;
  onImageEditorOpen?: () => void;

  /*
   * @deprecated Not possible to configure. Spoiler is disabled by default.
   */
  spoiler?: SpoilerConfig;
  /*
   * @deprecated Use disableDownload and disableExpand instead.
   */
  defaultData?: {
    config?: ImageConfig;
    disableExpand?: boolean;
  };
  /*
   * @deprecated
   */
  imageProps?: HTMLImageElement;
  /*
   * @deprecated
   */
  createGalleryForMultipleImages?: boolean;
  /*
   * @deprecated
   */
  imageEditor?: boolean;
  /*
   * @deprecated
   */
  consumer?: string;
}

type ImageSrc = Record<string, unknown>;
export interface ImagePluginViewerConfig extends ViewerPluginConfig, ImageConfig {
  onExpand?: (blockkey: string) => unknown;
  disableExpand?: boolean;
  disableTransition?: boolean;
  imageProps?: ((src: ImageSrc) => HTMLImageElement) | HTMLImageElement;
}

/*
 * @deprecated Use ImageData from ricos-schema instead.
 */
export interface ImageData {
  config: ImageConfig;
  src: { fallback?: string; width: number; height: number; id?: string; file_name?: string };
  metadata?: { caption?: string; alt?: string | undefined };
  [key: string]: unknown;
  disableDownload?: boolean;
  disableExpand?: boolean;
}

/*
 * @deprecated Use ImageData from ricos-schema instead.
 */
export interface TiptapImageData {
  containerData: {
    alignment?: string;
    width?: { size?: string };
    textWrap?: boolean;
    spoiler?: SpoilerConfig;
  };
  link?;
  disableExpand?: boolean;
  disableDownload?: boolean;
  caption?: string;
  altText?: string;
  image: {
    src: {
      id?: string;
    };
    width: number;
    height: number;
  };
}

export type ExtendedBlob = Blob & {
  lastModified: number;
  name: string;
  webkitRelativePath: string;
};
